// @ts-ignore
import Index from './src/Index.vue'
import {withInstall} from "../../utils/install";

Index.name = 'form-modal';
export const FormModal = withInstall(Index);

export default FormModal;

